/* eslint-disable camelcase */
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Field, FieldArray } from 'redux-form';

import BasicText from '../../../../../shared/components/formComponents/groups/BasicText';
import BasicNumericInput from '../../../../../shared/components/formComponents/groups/BasicNumericInput';
import { VerbRichTextEditor } from '../../../../../shared/components/formComponents/VerbRichTextEditor';
import RichTextNotesHeader from './RichTextNotesHeader';
import CopyAssetLink from '../../../../components/CopyAssetLink';

class FileOptions extends Component {
    static propTypes = {
        fields: PropTypes.object.isRequired,
        contentValues: PropTypes.shape({
            numberOfFiles: PropTypes.number
        }).isRequired,
        disabled: PropTypes.bool
    };

    UNSAFE_componentWillReceiveProps(nextProps) {
        const {
            fields,
            contentValues: { numberOfFiles = 0 }
        } = this.props;
        const nextNumberOfFiles = nextProps.contentValues.numberOfFiles || 0;
        if (numberOfFiles !== nextNumberOfFiles) {
            const currentVals = {};

            fields.forEach((name, idx) => {
                const val = nextProps.fields.get(idx);
                currentVals[idx] = val;
            });

            nextProps.fields.removeAll();

            for (let scoreIdx = 0; scoreIdx < nextNumberOfFiles; scoreIdx += 1) {
                if (currentVals[scoreIdx]) {
                    nextProps.fields.push({
                        ...currentVals[scoreIdx]
                    });
                } else {
                    nextProps.fields.push({
                        fileTitle: '',
                        fileDescription: ''
                    });
                }
            }
        }
    }

    render() {
        const { fields, disabled } = this.props;
        return (
            <div>
                {fields.map((name, idx) => (
                    <div key={idx} className={'likertSectionItem-optionInput col-12 row'}>
                        <Field
                            name={`${name}.fileTitle`}
                            label={'File Title'}
                            className={'col-6'}
                            component={BasicText}
                            displayHelp={false}
                            disabled={disabled}
                        />
                        <Field
                            name={`${name}.fileDescription`}
                            label={'File Description (optional)'}
                            className={'col-6'}
                            component={BasicText}
                            displayHelp={false}
                            disabled={disabled}
                        />
                    </div>
                ))}
            </div>
        );
    }
}

class FileUploadSectionItem extends Component {
    static propTypes = {
        memberReference: PropTypes.string,
        sectionItemId: PropTypes.string,
        assetLinkOptions: PropTypes.array,
        isGlobalSectionItem: PropTypes.bool,
        contentValues: PropTypes.object
    };

    render() {
        const { memberReference, sectionItemId, contentValues, isGlobalSectionItem } = this.props;

        return (
            <div key={`${memberReference}-${sectionItemId}`} className={'col-12 file-upload-section-item'}>
                <div className={'row'}>
                    <div className={'col-7'}>
                        <Field
                            name={memberReference ? `${memberReference}.content.description` : 'content.description'}
                            label={'Description'}
                            placeholder={'Enter a description'}
                            component={VerbRichTextEditor}
                            readOnly={isGlobalSectionItem}
                            rows={3}
                        />
                    </div>
                    <div className={'col-5 mt-4'}>
                        <RichTextNotesHeader />
                        <CopyAssetLink assetLinkOptions={this.props.assetLinkOptions} />
                    </div>
                </div>
                <Field
                    name={memberReference ? `${memberReference}.content.numberOfFiles` : 'content.numberOfFiles'}
                    label={'File Count'}
                    className={'col-12'}
                    component={BasicNumericInput}
                    defaultValue={1}
                    minValue={1}
                    maxValue={5}
                    disabled={isGlobalSectionItem}
                />
                <FieldArray
                    name={memberReference ? `${memberReference}.content.fileOptions` : 'content.fileOptions'}
                    contentValues={contentValues}
                    component={FileOptions}
                    disabled={isGlobalSectionItem}
                />
            </div>
        );
    }
}

export default FileUploadSectionItem;
